import { render, staticRenderFns } from "./PalletRackSector.vue?vue&type=template&id=0235953f"
import script from "./PalletRackSector.vue?vue&type=script&lang=js"
export * from "./PalletRackSector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports